import React from "react";
import PropTypes from "prop-types";
import { changePassword, fetchPasswordPolicy } from "actions/changePasswordActions";
import { Card, CardSection } from "cxa-components";
import { ClientLogo } from "@cxagroup/casper";
import { removeResetExpirePasswordAction } from "actions/loginActions";
import ChangePasswordForm from "./ChangePasswordForm";
import { connect } from "react-redux";
import { RouteMap } from "components/common/navigation/routeMap";
import LogoPP from "../common/LogoPP";

class ChangePasswordPage extends React.Component {
  doRedirect(props = this.props) {
    const {
      removeResetExpirePasswordAction,
      user: { pendingAuthActions, employee, hrAdmin } = {},
      isAuthenticated,
      submitted,
      push,
    } = props;
    if (isAuthenticated) {
      if (submitted) {
        if (pendingAuthActions.length > 0) {
          setTimeout(() => removeResetExpirePasswordAction(), 3000);
        }
        push("/logout");
      } else if (hrAdmin && employee) {
        // Redirect to CXA dashboard page when impersonate employee is on-going
        // HR should not be able to access change password page
        // eslint-disable-next-line xss/no-location-href-assign
        location.href = RouteMap.CXAMain;
      }
    }
  }

  componentDidMount() {
    const { client, fetchPasswordPolicy } = this.props;
    fetchPasswordPolicy(client && { clientName: client });
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.doRedirect();
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate(nextProps) {
    this.doRedirect(nextProps);
  }

  render() {
    const {
      changePassword,
      resetExpiredPasswordMode,
      client,
      logoUrl,
      user: { employee, hrAdmin } = {},
    } = this.props;

    // Do not render if impersonate employee user
    // Show unauthorized access message here
    if (hrAdmin && employee) {
      return null;
    }

    return resetExpiredPasswordMode ? (
      <div className="login-wrapper">
        <Card>
          <header>
            {logoUrl ? (
              <ClientLogo client={client} logoUrl={logoUrl} size="large" />
            ) : (
              <LogoPP width={240} />
            )}
          </header>
          <CardSection>
            <ChangePasswordForm onSubmit={changePassword} {...this.props} />
          </CardSection>
        </Card>
      </div>
    ) : (
      <div className="o-layout">
        <div className="o-layout__item u-1/2@desktop">
          <Card>
            <CardSection>
              <ChangePasswordForm onSubmit={changePassword} {...this.props} />
            </CardSection>
          </Card>
        </div>
      </div>
    );
  }
}

ChangePasswordPage.propTypes = {
  client: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  logoUrl: PropTypes.string,
  changePassword: PropTypes.func.isRequired,
  fetchPasswordPolicy: PropTypes.func,
  push: PropTypes.func,
  changeSelectedLanguage: PropTypes.func,
  resetExpiredPasswordMode: PropTypes.bool,
};

const mapStateToProps = (
  {
    app: { client, clientName },
    changePassword: { response, submitting, submitted, policyDescription },
    login: { isAuthenticated, user },
    common: { isFetching, logoUrl },
  },
  { location: { pathname } }
) => ({
  client,
  response,
  logoUrl,
  submitting,
  submitted,
  policyDescription,
  isAuthenticated,
  user,
  pathname,
  resetExpiredPasswordMode: user.pendingAuthActions.length > 0,
});

const mapDispatchToProps = dispatch => ({
  changePassword: data => dispatch(changePassword(data)),
  fetchPasswordPolicy: data => dispatch(fetchPasswordPolicy(data)),
  removeResetExpirePasswordAction: () => dispatch(removeResetExpirePasswordAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePasswordPage);



// WEBPACK FOOTER //
// ./components/password/ChangePasswordPage.js